import type { CSSProperties } from 'react';
import { FormattedNumber } from 'react-intl';
import styled from 'styled-components';

import type { BonusOrdinalRatingEnum } from '@sorare/core/src/__generated__/globalTypes';
import { CollectionArrow } from '@sorare/core/src/atoms/icons/CollectionArrow';
import { BrandXXS } from '@sorare/core/src/atoms/typography';
import { Chip } from '@sorare/core/src/atoms/ui/Chip';

const StyledChip = styled(Chip)`
  background: rgba(var(--color), 0.2);
  color: rgb(var(--color));
  gap: 2px;

  &.EXCEPTIONAL {
    --color: var(--c-rgb-score-high);
  }
  &.VERY_HIGH {
    --color: var(--c-rgb-score-mediumHigh);
  }
  &.HIGH {
    --color: var(--c-rgb-score-medium);
  }
  &.MEDIUM {
    --color: var(--c-rgb-score-mediumLow);
  }
  &.LOW {
    --color: var(--c-rgb-score-low);
  }
  &.VERY_LOW {
    --color: var(--c-rgb-score-veryLow);
  }
  &.setColor {
    --color: var(--set-color-rgb, var(--c-rgb-white));
  }
`;

type Props = {
  bonusRating: BonusOrdinalRatingEnum | null;
  bonus?: number | null;
  withSetColor?: boolean;
  // rgb triple ("r, g, b") of the live set's colour, provided by the caller
  // when withSetColor is set.
  setColorRgb?: string;
};

export const ContenderBonus = ({
  bonusRating,
  bonus,
  withSetColor,
  setColorRgb,
}: Props) => {
  return (
    <StyledChip
      size="small"
      className={withSetColor ? 'setColor' : bonusRating || undefined}
      style={
        {
          '--set-color-rgb': setColorRgb ?? 'var(--c-rgb-white)',
        } as CSSProperties
      }
    >
      <CollectionArrow size={1} color="currentColor" />
      {typeof bonus === 'number' && (
        <BrandXXS color="currentColor">
          <FormattedNumber value={bonus} maximumFractionDigits={0} />
        </BrandXXS>
      )}
    </StyledChip>
  );
};
